/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sage_Kind_Gull_WadeInputs */

const en_sage_kind_gull_wade = /** @type {(inputs: Sage_Kind_Gull_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No access`)
};

const de_sage_kind_gull_wade = /** @type {(inputs: Sage_Kind_Gull_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Zugriff`)
};

/**
* | output |
* | --- |
* | "No access" |
*
* @param {Sage_Kind_Gull_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sage_kind_gull_wade = /** @type {((inputs?: Sage_Kind_Gull_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sage_Kind_Gull_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sage_kind_gull_wade(inputs)
	return de_sage_kind_gull_wade(inputs)
});